import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import { optionsVAT } from "constants/IssueInvoiceConstant";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  createVATManager,
  detailVATManager,
  listVATManager,
  resetDetailVATManager,
  resetUpdateVATManager,
  updateVATManager,
} from "store/actions";
import * as yup from "yup";
import { userModeList } from "./utils";

const DetailUser = props => {
  const {
    isOpenModal,
    dataDetail,
    toggleModal,
    mode,
    employeeList,
    userRoleList,
    userVATManager,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["VATManager"]);
  const { addToast } = useToasts();

  const userManagement = useSelector(state => state.VATManager);
  const {
    loadingDetail,
    errorDetail,
    detail: VATDetail,
    create: userCreate,
    loadingUpdate,
    errorUpdate,
    errorCreate,
    update: userUpdate,
  } = userManagement;

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail
  const [valueTsuat, setValueTsuat] = useState(null);
  const initControlFields = {
    display: {
      name_VAT: false,
      tsuat: false,
      record_status: false,
      btn_save: false,
    },
  };

  const [controlFields, setControlFields] = useState(initControlFields);

  const schema = yup.object().shape({
    name_VAT: yup.object(),
    tsuat: yup.string(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      name_VAT: {},
      tsuat: "",
    },
  });

  useEffect(() => {
    if (!isOpenModal) {
      dispatch(resetDetailVATManager());
      setIsDetail(false);
      setControlFields(initControlFields);
    }
  }, [dispatch, isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.userId && !isDetail) {
        dispatch(detailVATManager(dataDetail.userId));
      }
    }
  }, [dataDetail, dispatch, isDetail, isOpenModal]);
  // useEffect(() => {
  //   if (valueTsuat) {
  //     setValue("tsuat", valueTsuat.value);
  //   }
  // }, [valueTsuat]);

  // Set Data Detail
  useEffect(() => {
    if (isOpenModal) {
      if (VATDetail && VATDetail.success && !isDetail) {
        let username = "";
        const defaultValues = {
          user_profile_id: undefined,
          user_role: [],
        };
        reset({});
        const dataReset = {};

        dataReset["name_VAT"] = VATDetail.ltsuat;
        dataReset["tsuat"] = VATDetail.tsuat;

        switch (mode) {
          case userModeList.VIEW_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });

            if (VATDetail) {
              const temp = options.find(
                item => item.label === VATDetail.ltsuat
              );
              setValue("name_VAT", temp);
              setValue("tsuat", VATDetail.tsuat);
            }

            setValue("record_status", VATDetail.record_status);

            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                user_login: true,
                record_status: true,
                user_role: true,
              },
            });
            break;
          case userModeList.EDIT_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });

            if (VATDetail) {
              const temp = optionsVAT.find(
                item => item.label === VATDetail.ltsuat
              );
              setValue("name_VAT", temp);
              setValue("tsuat", VATDetail.tsuat);
            }
            setValue("record_status", VATDetail.record_status, {
              shouldValidate: true,
            });
            if (VATDetail.user_profile) {
              setDataUserProfile({
                value: VATDetail.user_profile.id,
                label: VATDetail.user_profile.code,
              });
            }

            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                user_login: true,
                record_status: true,
                user_role: true,
                btn_save: true,
              },
            });
            break;
          default:
            break;
        }
        setIsDetail(true);
      } else {
        if (Object.keys(dataDetail).length === 0) {
          setControlFields({
            display: {
              ...initControlFields.display,
              user_profile_id: true,
              user_profile_phone: true,
              user_profile_name: true,
              user_profile_email: true,
              user_login: true,
              user_role: true,
              btn_save: true,
            },
          });
          setValue("name_VAT", "");
          setValue("tsuat", "");
        }
      }
    }
  }, [isDetail, isOpenModal, mode, reset, setValue, VATDetail]);

  // Action Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (userUpdate && userUpdate.success) {
        addToast(t("form.submit.update.user.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(
          listVATManager({
            ...(userVATManager && userVATManager.params),
            page: 1,
            sizePerPage: 10,
          })
        );
        dispatch(resetUpdateVATManager());
        toggleModal(mode);
      }
    }
  }, [addToast, dispatch, isOpenModal, mode, t, userUpdate]);
  useEffect(() => {
    if (errorCreate) {
      if (errorCreate.code && errorCreate.code === 422) {
        addToast("Tên VAT đã bị trùng, vui lòng thử lại tên khác", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetUpdateVATManager());
      }
    }
  }, [errorCreate]);
  // Error Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (errorDetail && errorDetail.message) {
        addToast(errorDetail.message, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDetailVATManager());
      }

      if (errorUpdate) {
        if (errorUpdate.code && errorUpdate.code === 422) {
          addToast("Tên VAT đã bị trùng, vui lòng thử lại tên khác", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        if (
          errorUpdate &&
          errorUpdate.fields &&
          errorUpdate.fields.length > 0
        ) {
          errorUpdate.fields.map(item => {
            let fieldName = item.field;
            switch (item.field) {
              case "usprofile_id":
                fieldName = "user_profile_id";
                break;
              case "username":
                fieldName = "user_login";
                break;
              case "roles":
                fieldName = "user_role";
                break;
              case "common":
                addToast(item.message, {
                  appearance: "error",
                  autoDismiss: true,
                });
                break;
              default:
                break;
            }
            setError(fieldName, { type: "manual", message: item.message });
          });
        }
        dispatch(resetUpdateVATManager());
        if (errorUpdate.code !== 422) {
          toggleModal(mode);
        }
      }
    }
  }, [
    addToast,
    dispatch,
    errorDetail,
    errorUpdate,
    isOpenModal,
    mode,
    setError,
    toggleModal,
  ]);
  const setSelectedTSuat = value => {
    setValue("tsuat", value.value);
    setValue("name_VAT", value);
  };
  const setDataUserProfile = data => {
    const userProfileId = data.value;
    const userProfile = employeeList.items.find(
      item => item.id === userProfileId
    );
    if (userProfile) {
      setValue("name_VAT", userProfile.ltsuat ? userProfile.ltsuat : "");
      setValue("tsuat", userProfile.tsuat ? userProfile.tsuat : "");
    }
  };
  useEffect(() => {
    if (userCreate && userCreate.success) {
      addToast(t("form.submit.create.user.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(
        listVATManager({
          ...(userVATManager && userVATManager.params),
          page: 1,
          sizePerPage: 10,
        })
      );
      dispatch(resetUpdateVATManager());
      toggleModal(mode);
    }
  }, [addToast, dispatch, t, userCreate]);
  const onSubmit = values => {
    switch (mode) {
      case userModeList.EDIT_USER_DETAIL:
        if (Object.keys(dataDetail).length === 0) {
          dispatch(
            createVATManager({
              ltsuat: values.name_VAT.label,
              tsuat: values.tsuat,
            })
          );
        } else {
          dispatch(
            updateVATManager(VATDetail.id, {
              ltsuat: values.name_VAT.label,
              tsuat: values.tsuat,
            })
          );
        }
        break;
      default:
        break;
    }
  };

  return (
    <Modal
      size="lg"
      isOpen={isOpenModal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggleModal}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggleModal}>
          {mode === userModeList.VIEW_USER_DETAIL && `${t("title.detail")}`}
          {mode === userModeList.EDIT_USER_DETAIL &&
          Object.keys(dataDetail).length === 0
            ? `${t("title.create")}`
            : controlFields.display.btn_save && `${t("title.edit")}`}
        </ModalHeader>
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="8"
              countButton="2"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Form>
                <Row className="row-cols-1 row-cols-md-2">
                  {controlFields.display.user_profile_phone && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="name_VAT">{t("table.name_VAT")}</Label>
                        <Controller
                          control={control}
                          name="name_VAT"
                          render={({ field }) => (
                            <Select
                              {...field}
                              onChange={e => {
                                setSelectedTSuat(e);
                              }}
                              isDisabled={
                                mode === userModeList.VIEW_USER_DETAIL
                              }
                              isOptionSelected={(option, selectValue) =>
                                selectValue.some(i => i === option)
                              }
                              options={optionsVAT}
                              classNamePrefix="select2-selection"
                            />
                          )}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="tsuat">{t("table.tsuat")}</Label>
                        <input
                          type="text"
                          readOnly
                          className="form-control"
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          {...register("tsuat")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Row className="justify-content-end">
                {controlFields.display.btn_save && (
                  <Col className="col-auto">
                    <Button
                      color="primary"
                      className="btn-label"
                      type="button"
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                      disabled={loadingUpdate}
                    >
                      <i className="bx bx-save label-icon"></i>
                      {t("form.save")}
                    </Button>
                  </Col>
                )}
              </Row>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailUser.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  employeeList: PropTypes.object,
  userRoleList: PropTypes.object,
  userVATManager: PropTypes.object,
};

DetailUser.defaultProps = {
  userVATManager: {},
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  employeeList: {},
  userRoleList: {},
};

export default DetailUser;
